/**
 * Quantity-mode (MDOT-24700) repository: the API surface behind the "Convert to quantities"
 * flow. Feature-owned so deleting the quantity feature removes it wholesale.
 */
import { getApiGen } from "$root/api/factory";
import { repositoryHelperFactory } from "$root/api/repository";
import { portfolioRepository } from "$root/functional-areas/portfolio/repository";
import { axiosExtract } from "$root/third-party-integrations/axios";
import { InvestmentEnhancementControllerV4ApiFactory } from "@eu.mdotm.api/sphere";

const { newAction } = repositoryHelperFactory("quantityConversion");

const enhancementApi = () => getApiGen(InvestmentEnhancementControllerV4ApiFactory);

export const quantityConversionRepository = {
	/**
	 * Converts the weight-based composition into quantities: creates a shares proposal that
	 * splits `totalAmount` (the AUM budget, in the portfolio base currency) across the current
	 * weights at the latest instrument prices.
	 */
	createSharesProposal: newAction(async (investmentUuid: string, totalAmount: number) => {
		await axiosExtract(enhancementApi().createSharesProposal(investmentUuid, { totalAmount }));
		portfolioRepository.invalidateEntity(investmentUuid);
	}),
} as const;
